import classNames from "classnames";
import { useFormik } from "formik";
import { get, isEmpty } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BsTrash, BsUpload } from "react-icons/bs";
import { MdOpenInNew } from "react-icons/md";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";
import ImageJustification from "shared/assets/images/lmf/lmf_justificative.png";
import HelpYellow from "shared/components/SVG/LMF/HelpYellow";
import { NAME_SPACES } from "shared/locales/constants";
import { CLIENT_CATEGORY } from "utils/constants";
import { bytesToMB } from "utils/helpers/files";
import { bindInputProps } from "utils/helpers/input";
import ActionButtons from "../Components/ActionButtons";
import Button from "../Components/Button";
import CustomModal from "../Components/CustomModal";
import Head from "../Components/Head";
import Input from "../Components/Input";
import Layout from "../Components/Layout";
import validation from "./validation";

const View = ({
  initialValues,
  onSubmit,
  locked,
  translate,
  profile,
  onBack,
}) => {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.PROCESSES);
  const [open, setOpen] = useState(false);
  const [openJustificatif, setOpenJustificatif] = useState(false);
  const isTerritorial = profile === CLIENT_CATEGORY.TERRITORIAL_AGENT;

  const { isValid, handleSubmit, setFieldValue, values, ...formProps } =
    useFormik({
      enableReinitialize: true,
      key: JSON.stringify(initialValues),
      initialValues,
      onSubmit: onSubmit,
      validationSchema: validation(
        t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, {
          returnObjects: true,
        }),
        { profile, isTerritorial },
      ),
    });

  const onFileRemove = async ({ uid: id }) => {
    if (id.indexOf("AUTO") !== -1) return;
  };

  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <>
      <CustomModal
        open={open}
        setOpen={setOpen}
        width={500}
        closeText={translate.MODAL.CLOSE}
      >
        <div className="with--link">
          <img src={ImageJustification} alt="Justification" />
          <Link
            to={
              "https://www.ameli.fr/assure/adresses-et-contacts/l-obtention-d-un-document/obtenir-une-attestation/obtenir-une-attestation-de-droits"
            }
            className="lmf__modal--link"
            target="_blank"
          >
            <span>{translate.MODAL.LINK}</span>
            <MdOpenInNew size={20} color="#FEC212" />
          </Link>
        </div>
      </CustomModal>

      <CustomModal
        open={openJustificatif}
        setOpen={setOpenJustificatif}
        width={420}
        title={translate.MODAL_JUSTIFICATIF.TITLE}
        description={translate.MODAL_JUSTIFICATIF.DESCRIPTION}
        closeText={translate.MODAL_JUSTIFICATIF.CLOSE}
      ></CustomModal>
      <Layout>
        <Head
          description={translate.DESCRIPTION}
          title={translate.TITLE}
          onBack={onBack}
        />
        <div className=" lmf__form grid--1 gap-24">
          <div className="justification__section--child">
            <Input
              type="file"
              variant="uploader"
              listType="picture"
              onUpload={(fileList) => {
                setFieldValue("cin", fileList);
              }}
              validTypes={translate.DOCUMENTS.ALLOWED_FILES_TYPE}
              onFileRemove={onFileRemove}
              fileList={get(values, "cin", [])}
            >
              <div className="upload">
                <div className="label">
                  <span>{translate.DOCUMENTS.TYPES.CIN}</span>
                  <div className="infos">
                    <span className="required">
                      <small>Obligatoire</small>
                    </span>
                  </div>
                  {get(values, "cin", []).map(({ name, size }, index) => (
                    <small key={`cin-${index}`}>
                      {name} - {bytesToMB(size)}MB
                    </small>
                  ))}
                </div>
                <Button
                  type={
                    get(values, "cin", []).length > 1
                      ? "danger-outline"
                      : "white"
                  }
                  size="middle"
                  onClick={(e) => {
                    if (get(values, "cin", []).length > 1) {
                      e.stopPropagation();
                      setFieldValue("cin", []);
                    }
                  }}
                >
                  {get(values, "cin", []).length > 1 ? (
                    <BsTrash size={20} />
                  ) : (
                    <BsUpload size={20} />
                  )}
                </Button>
              </div>
            </Input>
            {/* <span className="justification__section--child__caption">
                <span>{translate.DOCUMENTS.ACCEPT_FILES}</span>
                <span>{translate.DOCUMENTS.MAX_SIZE}</span>
              </span> */}
            {get(formProps.errors, "cin") && (
              <span className="error-message">
                {get(formProps.errors, "cin")}
              </span>
            )}
          </div>
          <div className="justification__section--child">
            <Input
              type="file"
              variant="uploader"
              listType="file"
              onUpload={(fileList) => {
                setFieldValue("paymentAccount", fileList);
              }}
              validTypes={translate.DOCUMENTS.ALLOWED_FILES_TYPE}
              onFileRemove={onFileRemove}
              fileList={get(values, "paymentAccount", [])}
            >
              {/* {isEmpty(get(values, "paymentAccount")) && (
                )} */}
              <div className="upload">
                <div className="label">
                  <span>{translate.DOCUMENTS.TYPES.RIB} </span>
                  <div className="infos">
                    <span className="required">
                      <small>Obligatoire</small>
                    </span>
                  </div>
                  {get(values, "paymentAccount", []).map(
                    ({ name, size }, index) => (
                      <small key={`paymentAccount-${index}`}>
                        {name} - {bytesToMB(size)}MB
                      </small>
                    ),
                  )}
                </div>

                <Button
                  type={
                    get(values, "paymentAccount", []).length
                      ? "danger-outline"
                      : "white"
                  }
                  size="middle"
                  onClick={(e) => {
                    if (get(values, "paymentAccount", []).length) {
                      e.stopPropagation();
                      setFieldValue("paymentAccount", []);
                    }
                  }}
                >
                  {get(values, "paymentAccount", []).length ? (
                    <BsTrash size={20} />
                  ) : (
                    <BsUpload size={20} />
                  )}
                </Button>
              </div>
            </Input>
            {get(formProps.errors, "paymentAccount") && (
              <span className="error-message">
                {get(formProps.errors, "paymentAccount")}
              </span>
            )}
          </div>
          <div className="justification__section--child">
            <Input
              type="file"
              variant="uploader"
              listType="picture"
              onUpload={(fileList) => {
                setFieldValue("bankAccountDetailsForPayment", fileList);
              }}
              validTypes={translate.DOCUMENTS.ALLOWED_FILES_TYPE}
              onFileRemove={onFileRemove}
              fileList={get(values, "bankAccountDetailsForPayment", [])}
            >
              {/* {isEmpty(get(values, "bankAccountDetailsForPayment")) && (
                )} */}
              <div className="upload">
                <div className="label">
                  <span>{translate.DOCUMENTS.TYPES.RIB_PRESTATION}</span>
                  {get(values, "bankAccountDetailsForPayment", []).map(
                    ({ name, size }, index) => (
                      <small key={`health-${index}`}>
                        {name} - {bytesToMB(size)}MB
                      </small>
                    ),
                  )}
                </div>
                <Button
                  type={
                    get(values, "bankAccountDetailsForPayment", []).length
                      ? "danger-outline"
                      : "white"
                  }
                  size="middle"
                  onClick={(e) => {
                    if (
                      get(values, "bankAccountDetailsForPayment", []).length
                    ) {
                      e.stopPropagation();
                      setFieldValue("bankAccountDetailsForPayment", []);
                    }
                  }}
                >
                  {get(values, "bankAccountDetailsForPayment", []).length ? (
                    <BsTrash size={20} />
                  ) : (
                    <BsUpload size={20} />
                  )}
                </Button>
              </div>
            </Input>
            {get(formProps.errors, "bankAccountDetailsForPayment") && (
              <span className="error-message">
                {get(formProps.errors, "bankAccountDetailsForPayment")}
              </span>
            )}
          </div>
          <div className="justification__section--child">
            <Input
              type="file"
              variant="uploader"
              listType="picture"
              onUpload={(fileList) => {
                setFieldValue("healthInsuranceRightsCertificate", fileList);
              }}
              validTypes={translate.DOCUMENTS.ALLOWED_FILES_TYPE}
              onFileRemove={onFileRemove}
              fileList={get(values, "healthInsuranceRightsCertificate", [])}
            >
              {/* {isEmpty(get(values, "healthInsuranceRightsCertificate")) && (
                )} */}
              <div className="upload">
                <div className="label">
                  <span>
                    {
                      translate.DOCUMENTS.TYPES
                        .HEALTH_INSURANCE_RIGHTS_CERTIFICATE
                    }
                  </span>

                  <div className="infos">
                    <span className="required">
                      <small>Obligatoire</small>
                      <HelpYellow
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpen(true);
                        }}
                        size={24}
                      />
                    </span>
                    <small className="hint">Datant de -3 mois</small>
                  </div>
                  {get(values, "healthInsuranceRightsCertificate", []).map(
                    ({ name, size }, index) => (
                      <small key={`health-${index}`}>
                        {name} - {bytesToMB(size)}MB
                      </small>
                    ),
                  )}
                </div>
                <Button
                  type={
                    get(values, "healthInsuranceRightsCertificate", []).length
                      ? "danger-outline"
                      : "white"
                  }
                  size="middle"
                  onClick={(e) => {
                    if (
                      get(values, "healthInsuranceRightsCertificate", []).length
                    ) {
                      e.stopPropagation();
                      setFieldValue("healthInsuranceRightsCertificate", []);
                    }
                  }}
                >
                  {get(values, "healthInsuranceRightsCertificate", [])
                    .length ? (
                    <BsTrash size={20} />
                  ) : (
                    <BsUpload size={20} />
                  )}
                </Button>
              </div>
            </Input>
            {get(formProps.errors, "healthInsuranceRightsCertificate") && (
              <span className="error-message">
                {get(formProps.errors, "healthInsuranceRightsCertificate")}
              </span>
            )}
            <Input
              type="checkbox"
              label={translate.INCLUDED_CHILDREN}
              checked={get(values, "includedChildren")}
              {...bindInputProps({
                name: "includedChildren",
                values,
                ...formProps,
              })}
              onChange={({ target: { checked } }) => {
                setFieldValue("includedChildren", checked);
              }}
              disabled={locked}
            />
          </div>
          {isTerritorial && (
            <div className="justification__section--child">
              <Input
                type="file"
                variant="uploader"
                listType="picture"
                onUpload={(fileList) => {
                  setFieldValue("proofOfEligibility", fileList);
                }}
                validTypes={translate.DOCUMENTS.ALLOWED_FILES_TYPE}
                onFileRemove={onFileRemove}
                fileList={get(values, "proofOfEligibility", [])}
              >
                <div className="upload">
                  <div className="label">
                    <span>
                      {translate.DOCUMENTS.TYPES.ELIGIBILITY}
                      <div className="infos">
                        <span className="required">
                          <small>Obligatoire</small>
                        </span>
                      </div>
                      {profile === CLIENT_CATEGORY.TERRITORIAL_AGENT && (
                        <HelpYellow
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpenJustificatif(true);
                          }}
                          size={24}
                        />
                      )}
                    </span>

                    {get(values, "proofOfEligibility", []).map(
                      ({ name, size }, index) => (
                        <small key={`proof-${index}`}>
                          {name} - {bytesToMB(size)}MB
                        </small>
                      ),
                    )}
                  </div>

                  <Button
                    type={
                      get(values, "proofOfEligibility", []).length
                        ? "danger-outline"
                        : "white"
                    }
                    size="middle"
                    onClick={(e) => {
                      if (get(values, "proofOfEligibility", []).length) {
                        e.stopPropagation();
                        setFieldValue("proofOfEligibility", []);
                      }
                    }}
                  >
                    {get(values, "proofOfEligibility", []).length ? (
                      <BsTrash size={20} />
                    ) : (
                      <BsUpload size={20} />
                    )}
                  </Button>
                </div>
              </Input>

              {get(formProps.errors, "proofOfEligibility") && (
                <span className="error-message">
                  {get(formProps.errors, "proofOfEligibility")}
                </span>
              )}
            </div>
          )}
        </div>

        <ActionButtons
          disabled={
            !isEmpty(formProps.errors) || isEmpty(get(values, "cin", []))
          }
          onNext={handleSubmit}
          buttonText={translate.NEXT}
          {...(isMobile && { onBack })}
          className={classNames({
            "w-100": isMobile,
          })}
        />
      </Layout>
    </>
  );
};

export default View;
